import { draftEntityTransformer } from 'util/draftEntityTransformer';

import { RawDraftContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

export const draftToHtmlWithLineBreaks = (rawContent: RawDraftContentState): string => {
  return draftToHtml(rawContent, undefined, undefined, draftEntityTransformer).replace(
    /<p><\/p>/g,
    '<p><br></p>',
  );
};
